import { IconButton, Flex, HStack, Heading } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useHistory } from 'react-router'
import { use100vh } from 'react-div-100vh'

type Props = {
  title: string
  noMb?: boolean
  previous?: () => void
}

const Layout: FC<Props> = ({ title, children, noMb, previous }) => {
  const height = use100vh()
  const history = useHistory()
  return (
    <Flex
      pos="relative"
      flexDir="column"
      maxW={{ md: '480px' }}
      w="full"
      mx="auto"
      pb="2.4rem"
      px="2.4rem"
      pt="1.2rem"
      h={height || undefined}>
      <HStack mb="1rem" pb={noMb ? 0 : '2.4rem'}>
        <IconButton
          justifyContent="flex-start"
          onClick={previous || (() => history.goBack())}
          color="transparent"
          bg="transparent"
          w="30px"
          _hover={{ bg: 'transparent' }}
          _active={{ bg: 'transparent' }}
          _focus={{ bg: 'transparent' }}
          aria-label="Search database"
          icon={
            <svg
              width="15"
              height="14"
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.4451 6.10003H14.3996V7.89997H3.4451L8.27256 12.7274L7 14L0 7L7 0L8.27256 1.27256L3.4451 6.10003Z"
                fill="#2E279D"
              />
            </svg>
          }
        />
        <Heading
          fontWeight="600"
          ml="-48px !important"
          flex="1"
          textAlign="center"
          fontSize="1.6rem"
          color="black">
          {title}
        </Heading>
      </HStack>
      {children}
    </Flex>
  )
}

export { Layout }
